export const castMembers = [
  {
    id: "shen-yanqing",
    name: "沈砚青",
    avatar:
      "https://readdy.ai/api/search-image?query=elegant%20young%20actress%20portrait%20studio%20headshot%20with%20warm%20cream%20backdrop%2C%20soft%20window%20light%2C%20calm%20confident%20expression%2C%20editorial%20beauty%20photography&width=400&height=400&seq=duanju-cast-01a&orientation=squarish",
    dramaCount: 14,
    bestKnown: "《重生之假千金上门》",
    role: "新生代女主",
    bio:
      "以细腻克制的表演风格受到关注，擅长处理沉默中的情绪变化。代表作集中在都市与现实题材短剧。",
    works: ["重生之假千金上门", "归来仍是少年郎", "长街灯火"],
  },
  {
    id: "gu-nanchen",
    name: "顾南宸",
    avatar:
      "https://readdy.ai/api/search-image?query=handsome%20young%20actor%20portrait%20studio%20headshot%20with%20warm%20cream%20backdrop%2C%20soft%20window%20light%2C%20sharp%20tailored%20dark%20suit%2C%20editorial%20fashion%20photography&width=400&height=400&seq=duanju-cast-01b&orientation=squarish",
    dramaCount: 11,
    bestKnown: "《闪婚后，总裁每天都在宠我》",
    role: "都市男主",
    bio:
      "外形冷峻，台词功底扎实，常被安排出演克制型角色。近年来尝试更多现实题材，口碑稳步上升。",
    works: ["闪婚后，总裁每天都在宠我", "民国小厨娘", "深夜食堂"],
  },
  {
    id: "lu-zhaoning",
    name: "陆昭宁",
    avatar:
      "https://readdy.ai/api/search-image?query=elegant%20ancient%20chinese%20costume%20actress%20portrait%20studio%20headshot%20with%20warm%20crimson%20backdrop%2C%20soft%20candlelight%2C%20regal%20expression%2C%20editorial%20beauty%20photography&width=400&height=400&seq=duanju-cast-03a&orientation=squarish",
    dramaCount: 17,
    bestKnown: "《长公主在上》",
    role: "古装主力",
    bio:
      "古装表现力突出，眼神戏被观众反复讨论。坚持亲自完成大部分武打与走位调度，拍摄效率很高。",
    works: ["长公主在上", "民国小厨娘", "凤仪天下"],
  },
  {
    id: "pei-chenzhou",
    name: "裴沉舟",
    avatar:
      "https://readdy.ai/api/search-image?query=young%20ancient%20chinese%20emperor%20costume%20male%20portrait%20studio%20headshot%20with%20dark%20crimson%20backdrop%2C%20dramatic%20lighting%2C%20intense%20expression%2C%20cinematic%20photography&width=400&height=400&seq=duanju-cast-03c&orientation=squarish",
    dramaCount: 9,
    bestKnown: "《我的师父是剑仙》",
    role: "演员 / 导演",
    bio:
      "身兼演员与导演，玄幻与古装题材经验丰富。习惯在拍摄现场亲自示范动作，对镜头调度有明确判断。",
    works: ["我的师父是剑仙", "山海秘闻录", "长公主在上"],
  },
  {
    id: "jiang-ye",
    name: "江野",
    avatar:
      "https://readdy.ai/api/search-image?query=young%20man%20portrait%20studio%20headshot%20with%20warm%20beige%20backdrop%2C%20soft%20natural%20light%2C%20gentle%20honest%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-02a&orientation=squarish",
    dramaCount: 12,
    bestKnown: "《归来仍是少年郎》",
    role: "现实题材演员",
    bio:
      "擅长演绎小人物，表演松弛自然。为贴近角色常提前到取景地生活，被剧组称为「最不像在演戏的演员」。",
    works: ["归来仍是少年郎", "彩礼风波", "山海秘闻录"],
  },
  {
    id: "xie-yunjie",
    name: "谢云阶",
    avatar:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20scholar%20scholar%20costume%20male%20portrait%20studio%20headshot%20with%20warm%20amber%20backdrop%2C%20soft%20lighting%2C%20thoughtful%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-03b&orientation=squarish",
    dramaCount: 10,
    bestKnown: "《长公主在上》",
    role: "谋士专业户",
    bio:
      "气质文雅，台词节奏稳健，多次出演谋士、书生类角色。对古代礼仪做过系统功课，能自行调整执礼动作。",
    works: ["长公主在上", "末班地铁的陌生人", "山海秘闻录"],
  },
  {
    id: "wen-yining",
    name: "温以宁",
    avatar:
      "https://readdy.ai/api/search-image?query=mature%20elegant%20chinese%20woman%20portrait%20studio%20headshot%20with%20warm%20cream%20backdrop%2C%20soft%20lighting%2C%20poised%20expression%2C%20editorial%20beauty%20photography&width=400&height=400&seq=duanju-cast-01c&orientation=squarish",
    dramaCount: 22,
    bestKnown: "《长公主在上》",
    role: "戏骨配角",
    bio:
      "舞台剧出身，气场稳定。常出演家族长辈与掌权者角色，一个眼神就能改变整场戏的重量。",
    works: ["长公主在上", "重生之假千金上门", "神级鉴宝师"],
  },
  {
    id: "qin-ziyue",
    name: "秦子越",
    avatar:
      "https://readdy.ai/api/search-image?query=young%20serious%20male%20actor%20portrait%20studio%20headshot%20with%20warm%20cream%20backdrop%2C%20soft%20window%20light%2C%20neutral%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-01d&orientation=squarish",
    dramaCount: 13,
    bestKnown: "《神级鉴宝师》",
    role: "男主 / 反派",
    bio:
      "正邪角色都能驾驭，近年频繁出现在爽感题材中。表演外放但有节制，懂得为对手戏留空间。",
    works: ["神级鉴宝师", "我的师父是剑仙", "重生之假千金上门"],
  },
  {
    id: "lin-zhixia",
    name: "林知夏",
    avatar:
      "https://readdy.ai/api/search-image?query=lively%20young%20woman%20portrait%20studio%20headshot%20with%20warm%20terracotta%20backdrop%2C%20bright%20soft%20light%2C%20cheerful%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-04c&orientation=squarish",
    dramaCount: 15,
    bestKnown: "《彩礼风波》",
    role: "生活流女主",
    bio:
      "笑容有感染力，擅长把生活化的对白说出真实感。多在现实题材中担任推进剧情的关键角色。",
    works: ["彩礼风波", "闪婚后，总裁每天都在宠我", "神级鉴宝师"],
  },
  {
    id: "zhou-huilan",
    name: "周惠兰",
    avatar:
      "https://readdy.ai/api/search-image?query=warm%20middle%20aged%20chinese%20mother%20portrait%20studio%20headshot%20with%20beige%20backdrop%2C%20soft%20lighting%2C%20kind%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-02b&orientation=squarish",
    dramaCount: 19,
    bestKnown: "《彩礼风波》",
    role: "家庭题材常客",
    bio:
      "被观众称为「最像自己妈妈的演员」。善于用细小的生活动作堆出人物的重量，收放自如。",
    works: ["彩礼风波", "归来仍是少年郎", "小巷人家"],
  },
  {
    id: "cheng-tong",
    name: "程桐",
    avatar:
      "https://readdy.ai/api/search-image?query=thoughtful%20young%20woman%20portrait%20studio%20headshot%20with%20warm%20grey%20backdrop%2C%20soft%20lighting%2C%20quiet%20curious%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-06a&orientation=squarish",
    dramaCount: 8,
    bestKnown: "《末班地铁的陌生人》",
    role: "悬疑新人",
    bio:
      "在悬疑题材中表现亮眼，情绪层次清晰。毕业于戏剧院校，习惯为角色写人物小传。",
    works: ["末班地铁的陌生人", "山海秘闻录", "雾中来信"],
  },
  {
    id: "su-rong",
    name: "苏软",
    avatar:
      "https://readdy.ai/api/search-image?query=sweet%20young%20actress%20portrait%20studio%20headshot%20with%20warm%20peach%20backdrop%2C%20soft%20lighting%2C%20playful%20smile%2C%20editorial%20beauty%20photography&width=400&height=400&seq=duanju-cast-04a&orientation=squarish",
    dramaCount: 16,
    bestKnown: "《闪婚后，总裁每天都在宠我》",
    role: "甜宠担当",
    bio:
      "形象清新，节奏感好，擅长轻喜剧与甜宠题材。近年尝试突破类型，挑战更复杂的情感线索。",
    works: ["闪婚后，总裁每天都在宠我", "小满的夏天", "今夕何夕"],
  },
];